import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ReservationLogin } from '../../Services/Service';

export const loginReservationUser = createAsyncThunk(
  'reservation/login',
  async ({ email, password }, thunkAPI) => {
    try {
      const response = await ReservationLogin(email, password);
      if (response?.token) {
        localStorage.setItem('ReservationAuthToken', response.token);
        return response;
      } else {
        return thunkAPI.rejectWithValue('Invalid credentials');
      }
    } catch (error) {
      return thunkAPI.rejectWithValue('Login failed');
    }
  }
);

const reservationSlice = createSlice({
  name: 'reservation',
  initialState: {
    token: localStorage.getItem('ReservationAuthToken') || null,
    loading: false,
    error: null,
  },
  reducers: {
    logoutReservationUser: (state) => {
      state.token = null;
      localStorage.removeItem('ReservationAuthToken');
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginReservationUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginReservationUser.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.token;
      })
      .addCase(loginReservationUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logoutReservationUser } = reservationSlice.actions;

export default reservationSlice.reducer;
